class NavGlobal extends HTMLElement {
  constructor() {
    super();

    this.header   = document.getElementById('header-global');
    this.burger   = document.getElementById('mobile-menu-trigger');
    this.navLinks = this.querySelectorAll('ul li');
    this.mark     = this.querySelector('mark');
  }

  connectedCallback() {
    this.InitNavigation();
    this.RegisterEventListeners();
  }

  /**
   * Sets the hover border to be positioned below the given li element in the global nav.
   * @param {HTMLLIElement} link 
   */
  SetMarkPos(link) {
    const anchor = link.firstElementChild;

    const computedStyles = getComputedStyle(anchor);
    const width = anchor.offsetWidth - (parseFloat(computedStyles.paddingLeft) + parseFloat(computedStyles.paddingRight));
    const xPos =  link.getBoundingClientRect().x + parseFloat(computedStyles.paddingLeft);
    this.mark.style.width = `${width}px`;
    this.mark.style.setProperty('--translate-X', `${xPos}px`);
    this.mark.style.setProperty('--opacity', `1`);
  }

  /**
   * Resets the position of the mark to the currently active page link.
   */
  ResetMarkPos() {
    if (this.current !== undefined) this.SetMarkPos(this.current);
    else this.mark.style.setProperty('--opacity', '0');
  }

  /**
   * Initialises the global navigation:
   * - Active class for <li>
   * - Mark position for hover functionality
   */
  InitNavigation() {
    this.navLinks.forEach(link => {
      if (document.body.dataset.current === link.dataset.id) {
        this.current = link;
        return;
      }
    });
    if (this.current === undefined) this.SetMarkPos(this.navLinks[0]);;
    this.ResetMarkPos();
  }

  /**
   * Registers all event listeners needed.
   */
  RegisterEventListeners() {
    this.burger.addEventListener('click', () => {
    
      this.header.classList.toggle('mobile-open');
      this.burger.classList.toggle('active');
      document.body.classList.toggle('overflow-hidden');
    });

    this.navLinks.forEach(link => {
      link.addEventListener('mouseover',  () => this.SetMarkPos(link));
      link.addEventListener('mouseleave', () => this.ResetMarkPos());
      link.addEventListener('click',      () => {
        this.current = link;
      });
    });

    window.addEventListener('resize', () => this.ResetMarkPos());
  }
}


customElements.define('nav-global', NavGlobal, {
  extends: 'nav'
});